export default __webpack_public_path__ + "static/media/W.d932cc55.png";